import { render, staticRenderFns } from "./LimitedAccessBanner.vue?vue&type=template&id=1bda50ce&scoped=true&"
import script from "./LimitedAccessBanner.vue?vue&type=script&lang=js&"
export * from "./LimitedAccessBanner.vue?vue&type=script&lang=js&"
import style0 from "./LimitedAccessBanner.vue?vue&type=style&index=0&id=1bda50ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bda50ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/harness/feed-manager-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bda50ce')) {
      api.createRecord('1bda50ce', component.options)
    } else {
      api.reload('1bda50ce', component.options)
    }
    module.hot.accept("./LimitedAccessBanner.vue?vue&type=template&id=1bda50ce&scoped=true&", function () {
      api.rerender('1bda50ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/limitedDistribution/LimitedAccessBanner.vue"
export default component.exports